import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { updateModalContent, toggleModal } from '../../actions/modal';
import StaffTable from './table';
import CreateStaff from './create';

const StaffList = ({ updateModalContent, toggleModal }) => {
  const formCreateRef = useRef();
  const [tableDataState, setTableDataState] = useState(false);

  const onAddStaff = () => {
    updateModalContent({
      title:        'Add new Staff',
      content:      <CreateStaff updateList={() => { setTableDataState(true); }} ref={formCreateRef} />,
      actionButton: {
        actionText: 'Save',
        actionType: 'primary',
        action:     () => formCreateRef.current.submitForm(),
      },
      cancelText:       'Cancel',
      closeAfterAction: false,
      width:            950,
    });

    toggleModal();
  };

  return (
    <div>
      <>
        <div className="content-header">
          <h1>Staff</h1>
          <Button variant="contained" onClick={() => onAddStaff()}>
            Add New Staff
          </Button>
        </div>

        <StaffTable updateListOnCreate={tableDataState} resetValue={() => setTableDataState(false)} />
      </>
    </div>
  );
};

export default connect(null, {
  toggleModal,
  updateModalContent,
})(StaffList);
